import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLocation, useParams } from "react-router-dom";

export const MobileHeader = (props) => {
  const { tabTitle, projectname, setOpenMenu, openMenu } = props;
  const location = useLocation();
  const [status, setStatus] = useState(location.pathname.split("/")[3]);
  return (
    <div
      className={`pd-theme fixed bottom-0 top-0 flex flex-col max-w-full bg-theme-paper bg-clip-padding shadow-theme-pop outline-none text-theme-fg-2 right-0 border-none w-full z-50`}
      style={{
        transform: openMenu ? "translateX(0)" : "translateX(100%)",
        transition: "transform 300ms ease-in-out",
      }}
      tabIndex={-1}
    >
      <div className="px-6 py-4 flex w-full justify-end">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          onClick={() => setOpenMenu(false)}
          fill="currentColor"
          className="bi bi-x-lg cursor-pointer "
          viewBox="0 0 16 16"
        >
          <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
        </svg>
      </div>
      <div className="flex-grow p-6 pt-2 overflow-y-auto">
        <header className="flex flex-col">
          {tabTitle &&
            tabTitle.map((item) => (
              <Link
                key={item.id}
                to={`/projects/${projectname}/${item.status}`}
              >
                <button
                  className={` ${
                    item.status === status
                      ? "!font-bold text-theme-fg-1"
                      : "border-transparent text-theme-fg-3"
                  } mb-3 mr-5 font-title text-sm font-normal`}
                  onClick={() => setStatus(item.status)}
                >
                  {item.label}
                </button>
              </Link>
            ))}
        </header>
      </div>
    </div>
  );
};
